require('./hireCardNerudaSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const { PENDING } = require('constants/hireCardSubmitScenarios');
const {
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL
} = require('constants/index');
const { catalogue, analyticsId } = require('../analytics/hireCardNerudaViewAnalytics');

class HireCardNerudaSuccess extends React.Component {

    buildSummary() {
        const {
            getContextTranslate,
            immAccount,
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${getContextTranslate('summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${getContextTranslate('summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${getContextTranslate('summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = formatText(paymentMethod[paymentMethodType]);
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${immHirePaymentMethod.get('value')} ${paymentMethodSymbol}`;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-neruda-success__summary">
                <div className="col-xs-6 hire-card-neruda-success__summary-left-column">
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value={getContextTranslate('summarySelectedName')}
                    />
                    <div className="col-xs-12 hire-card-neruda-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value={getContextTranslate('summarySelectedLimit')}
                    />
                    <OneLineSymbolAmount
                        amountObject={limitObj}
                        amountObjectFormatted={formatAmountObject(limitObj, true)}
                        className="col-xs-12 hire-card-neruda-success__summary-value"
                        language={getLanguage()}
                        trimDecimals={true}
                    />
                </div>
                <div className="col-xs-5 col-xs-offset-1">
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value="cardDetails-associatedAccount"
                    />
                    <div className="col-xs-12 hire-card-neruda-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                    <FormattedText
                        className="col-xs-12 hire-card-neruda-success__summary-title"
                        value={getContextTranslate('summaryPaymentMethod')}
                    />
                    <div className="col-xs-12 hire-card-neruda-success__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
            </div>
        );
    }

    buildTexts() {
        const {
            getContextTranslate,
            immHireCardNeruda,
            immShippingAddress,
         } = this.props;
        let textElement;
        let titleKey;

        const pendingAnalysis = immHireCardNeruda.get('hiringStatus') === PENDING;

        if (pendingAnalysis) {
            titleKey = getContextTranslate('successTitlePending');
            textElement = (
                <div className="col-xs-8 hire-card-neruda-success__text">
                    <FormattedText value={getContextTranslate('successText1Pending')} />
                </div>
            );
        } else {
            const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);

            titleKey = getContextTranslate('successTitleCompleted');
            textElement = (
                <div className="col-xs-8 hire-card-neruda-success__text">
                    <FormattedText value={getContextTranslate('successText1Completed')} />
                    <div className="hire-card-neruda-success__address">
                        <i className="hire-card-neruda-success__address-icon icon icon-s-locacion" />
                        {address}
                    </div>
                    <FormattedText value={getContextTranslate('successText2Completed')} />
                </div>
            );
        }

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { getContextTranslate, immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const url = formatText(getContextTranslate('successWarningUrl2'));
        const text = !!email ? getContextTranslate('successWarningTextSentByEmail') : getContextTranslate('successWarningTextUpdateEmail');
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="col-xs-12">
                <OKMessage type="informative">
                    <FormattedText value={getContextTranslate('successWarningText1')} />
                    &nbsp;
                    <OKLink modifier="inline" target="_blank" to={url}>
                        <FormattedText value={getContextTranslate('successWarningText2')} />
                    </OKLink>
                    &nbsp;
                    <FormattedText value={getContextTranslate('successWarningText3')} />
                    <div className="hire-card-neruda-success__message-paragraph">
                        <FormattedText value={text} injectedStrings={injectedString} />
                    </div>
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            getContextTranslate,
            immHireCardImageSelector,
            immHireCardNeruda,
            immProfile,
            processDetail,
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const wizardSuccessIcon = immHireCardNeruda.get('hiringStatus') === PENDING ? 'pending' : '';

            const goBackButton = {
                label: (
                    <FormattedText value={getContextTranslate("successBackButtonText")} />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    iconModifier={wizardSuccessIcon}
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText(titleKey)}
                    tealium={catalogue[analyticsId.NERURA_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-neruda-success">
                        <div className="row">
                            
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-card-neruda-success__card-image"
                                immImageData={immImageData}
                            />
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-card-neruda-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardNerudaSuccess.propTypes = {
    getContextTranslate: PropTypes.func.isRequired,
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardNeruda: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HireCardNerudaSuccess;
